<div>
  <h1 class="recherche text-uppercase">
    Le réseau immo qui <span style="color : #BADFFF">partage 100%</span> de ses mandats
    <span ngbTooltip="Avec accord préalable du propriétaire vendeur et précisé au mandat de vente.">
      <svg style="position: relative;top:-20px;" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle-fill" viewBox="0 0 16 16">
        <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
      </svg>
    </span> !
  </h1><br>
  <h5 class="recherche">
    <b>THE DOOR MAN</b> vous accompagne dans la réalisation de votre projet immobilier.
  </h5><br>
</div>
<div>
  <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs no-bullet">
    <li [ngbNavItem]="'estimer'">
      <a class="py-md-3 px-md-4" ngbNavLink>Estimer</a>
      <ng-template ngbNavContent>
        <app-estimer-bien></app-estimer-bien>
      </ng-template>
    </li>
    <li [ngbNavItem]="'acheter'">
      <a class="py-md-3 px-md-4" ngbNavLink>Acheter</a>
      <ng-template ngbNavContent>
        <app-acheter-bien></app-acheter-bien>
      </ng-template>
    </li>
    <li [ngbNavItem]="'louer'">
      <a class="py-md-3 px-md-4" ngbNavLink>Louer</a>
      <ng-template ngbNavContent>
        <app-louer-bien></app-louer-bien>
      </ng-template>
    </li>
  </ul>

  <div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>
